import { memo, useCallback, useState } from 'react'

import { Button, Text } from '@cash-me/react-components'
import { useRouter } from 'next/router'

import { Grid, Col } from 'components/grid'
import { SectionLabel } from 'components/section-label'
import { buildSimulatorUrl } from 'src/utils/buildSimulatorUrl'
import { formatCurrencyAbbreviated } from 'utils/formatCurrencyAbbreviated'
import { pushDataLayer } from 'utils/push-data-layer'

import { ANALYTICS_ACTION, ANALYTICS_CATEGORY, computePropertyValue, FLASK_SCALE } from './constants'
import { Flask } from './flask'
import * as S from './styles'

const IdealCredit = memo(() => {
  const router = useRouter()
  const [value, setValue] = useState<number>(FLASK_SCALE.min)

  const propertyValue = computePropertyValue(value)

  const handleCommit = useCallback((committed: number) => {
    pushDataLayer({
      category: ANALYTICS_CATEGORY,
      action: ANALYTICS_ACTION,
      label: `Crédito ideal - Ajuste de valor - ${formatCurrencyAbbreviated(committed)}`
    })
  }, [])

  const handleCtaClick = useCallback(() => {
    pushDataLayer({
      category: ANALYTICS_CATEGORY,
      action: ANALYTICS_ACTION,
      label: 'Crédito ideal - Simule agora'
    })

    location.href = buildSimulatorUrl(router.pathname, { medium: 'CreditoIdeal-SimularAgora' })
  }, [router.pathname])

  return (
    <S.IdealCredit>
      <Grid col={{ phone: 1, tablet: 1, desktop: 1 }}>
        <Col>
          <S.Container>
            <S.FlaskColumn>
              <Flask
                value={value}
                scale={FLASK_SCALE}
                onChange={setValue}
                onCommit={handleCommit}
                estimate={{ label: 'Valor estimado do Imóvel:', value: formatCurrencyAbbreviated(propertyValue) }}
              />
            </S.FlaskColumn>

            <S.Intro>
              <S.Header>
                <SectionLabel
                  size="body1"
                  weight="bold"
                  color="white"
                  barColor="var(--colors-blue-background-strong-default)"
                >
                  Crédito ideal
                </SectionLabel>

                <Text as="h2" size="heading2" weight="medium" color="var(--colors-neutral-text-contrast-default)">
                  Quanto você pode conseguir com o Empréstimo com Garantia de Imóvel?
                </Text>
              </S.Header>

              <Text as="p" size="body1" weight="regular" color="var(--colors-neutral-text-contrast-default)">
                A CashMe libera até 60% do valor do imóvel para você investir no que realmente importa.
              </Text>
            </S.Intro>

            <S.Results>
              <S.EstimateBox>
                <Text as="span" size="body1" weight="regular" color="#ffffffcc">
                  Valor estimado do Imóvel:
                </Text>
                <span aria-live="polite">
                  <Text as="span" size="heading4" weight="bold" color="var(--colors-neutral-text-contrast-default)">
                    {formatCurrencyAbbreviated(propertyValue)}
                  </Text>
                </span>
              </S.EstimateBox>

              <S.CtaWrapper>
                <Button color="primary" size="md" onClick={handleCtaClick}>
                  Simule agora
                </Button>
              </S.CtaWrapper>
            </S.Results>
          </S.Container>
        </Col>
      </Grid>
    </S.IdealCredit>
  )
})

IdealCredit.displayName = 'IdealCredit'

export default IdealCredit
